import fly from '@/utils/request'

// 登陆登出
export function userLogin(data) {
  return fly.post('ApiAdmin_login.html', data)
}

export function logout() {
  return fly.post('ApiAdmin_loginout.html')
}

//账号
export function getAccountDetail (data) {
  return fly.post('ApiAdmin_getAdminInfo.html', data)
}
//用户列表
export function getUserList(data) {
  return fly.post('ApiUser_getList.html', data)
}
//用户详情
export function getUserDetail(data) {
  return fly.post('ApiUser_getInfo.html', data)
}
//店铺列表
export function getShopList(data) {
  return fly.post('ApiShop_getList.html', data)
}
//店铺详情
export function getShopDetail(data) {
  return fly.post('ApiShop_getInfo.html', data)
}
//礼品列表
export function getGiftList(data) {
  return fly.post('ApiGifts_getList.html', data)
}
//礼品详情
export function getGiftDetail(data) {
  return fly.post('ApiGifts_getInfo.html', data)
}
//活动列表
export function getActiList(data) {
  return fly.post('ApiActivity_getList.html', data)
}
//活动详情
export function getActiDetail(data) {
  return fly.post('ApiActivity_getInfo.html', data)
}
//新增&编辑用户
export function updateUserInfo(data) {
  return fly.post('ApiUser_addOrUpdate.html', data)
}
//新增&编辑商铺
export function updateShopInfo(data) {
  return fly.post('ApiShop_addOrUpdate.html', data)
}
//新增&编辑礼品
export function updateGiftInfo(data) {
  return fly.post('ApiGifts_addOrUpdate.html', data)
}
//新增&编辑活动
export function updateActiInfo(data) {
  return fly.post('ApiActivity_addOrUpdate.html', data)
}
// 图片上传 img 图片数据流base64，type 类别
export function uploadImage (data) {
  return fly.post('api_uploadImage.html', data)
}
//批量生成店铺二维码
export function createShopsCode(data) {
  return fly.post('ApiShop_createShopsCode.html', data)
}
//批量生成用户二维码
export function createUserCode(data) {
  return fly.post('ApiUser_createUsersCode.html', data)
}
//导出用户数据
export function exportUserToExcel (data) {
  return fly.config.baseURL + '/ApiUser_getList.html?' + params(data)
}
export function params (obj) {
  var str = []
  for (var key in obj)
  if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined) {
    // str.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
    str.push(key + '=' + obj[key])
  }
  return str.join('&')
}